// Simple client wrapper to call backend auth endpoints.
// Usage: set USE_BACKEND=true and implement backend server described in SERVER_README.md

const API_BASE = window.__AUTH_API_BASE__ || '/api';

export async function register({ username, password }) {
  const res = await fetch(`${API_BASE}/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });
  return res.json();
}

export async function login({ username, password }) {
  const res = await fetch(`${API_BASE}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });
  return res.json();
}
